import _ from "lodash";
import React from "react";
import { compose, graphql } from "lib/apolloClient";
import { getAiUsageMetricsQuery } from "AppComponents/AIFeedbackStrip/modules/AIFeedbackStripQueries";
import { getAiUsageMetricsQueryFromCache } from "AppComponents/AIFeedbackStrip/modules/AIFeedbackStripGraphqlHelpers";

const GPTVisionCost = props => {
  const { aiUsageMetrics } = props;
  const { promptTokens = 0, completionTokens = 0 } = aiUsageMetrics;

  const cost = _.round(
    (promptTokens * 0.01 + completionTokens * 0.03) / 1000,
    3
  );
  return (
    <div>
      <div style={{ marginTop: "12px", paddingBottom: "12px" }}>------</div>
      <div>{`Input tokens: ${promptTokens}`}</div>
      <div>{`Output tokens: ${completionTokens}`}</div>
      <div>{`Cost: $${cost}`}</div>
    </div>
  );
};

export default compose(
  graphql(getAiUsageMetricsQuery, {
    name: "getAiUsageMetrics",
    skip: ({ metricsId }) => !metricsId,
    options: ({ metricsId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: metricsId,
      },
    }),
    props({ getAiUsageMetrics, ownProps: { metricsId, isData, isLoading } }) {
      const aiUsageMetrics = getAiUsageMetricsQueryFromCache({
        id: metricsId,
      });

      return {
        aiUsageMetrics,
        isData: !_.isEmpty(aiUsageMetrics) && isData,
        isLoading:
          _.includes([1, 2], getAiUsageMetrics.networkStatus) || isLoading,
      };
    },
  })
)(GPTVisionCost);
